var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import Select from "@atlaskit/select";
import { TextField } from "@atlassiansox/microscopekit";
var CreateClassificationForm = /** @class */ (function (_super) {
    __extends(CreateClassificationForm, _super);
    function CreateClassificationForm(props) {
        var _this = _super.call(this, props) || this;
        _this.dataTypeOptions = [
            { label: "UGC/Primary", value: "UGC/Primary" },
            { label: "UGC/Configuration", value: "UGC/Configuration" },
            { label: "UGC/PrimaryIdentifier", value: "UGC/PrimaryIdentifier" },
            { label: "UGC/Label", value: "UGC/Label" },
            { label: "PII/DirectRestricted", value: "PII/DirectRestricted" },
            { label: "PII/IndirectRestricted", value: "PII/IndirectRestricted" },
            { label: "PII/IndirectConfidential", value: "PII/IndirectConfidential" },
            { label: "PII/DirectRestrictedIdentifier", value: "PII/DirectRestrictedIdentifier" },
            { label: "Usage/DirectAction", value: "Usage/DirectAction" },
            { label: "Usage/IndirectAction", value: "Usage/IndirectAction" },
            { label: "Usage/AuditLog", value: "Usage/AuditLog" },
            { label: "Usage/ApplicationLog", value: "Usage/ApplicationLog" },
            { label: "Usage/Telemetry", value: "Usage/Telemetry" },
            { label: "Security/Credential", value: "Security/Credential" },
            { label: "Security/Secret", value: "Security/Secret" },
            { label: "Atlassian/Configuration", value: "Atlassian/Configuration" },
            { label: "Atlassian/Survey", value: "Atlassian/Survey" },
            { label: "Atlassian/Finance", value: "Atlassian/Finance" },
            { label: "Atlassian/Static", value: "Atlassian/Static" },
            { label: "Commerce/Transaction", value: "Commerce/Transaction" },
            { label: "None", value: "None" }
        ];
        _this.state = {
            classificationValue: "UGC/Primary",
            descriptionValue: "",
        };
        return _this;
    }
    CreateClassificationForm.prototype.render = function () {
        var _this = this;
        var onChange = this.props.onChange;
        return (React.createElement(React.Fragment, null,
            React.createElement(Select, { name: "selectDataType", className: "select-data-type", options: this.dataTypeOptions, defaultValue: { label: "UGC/Primary", value: "UGC/Primary" }, onChange: function (option) {
                    _this.setState({ classificationValue: option.value }, function () {
                        onChange(_this.state);
                    });
                } }),
            React.createElement(TextField, { name: "description", label: "Description (120 characters max)", value: this.state.descriptionValue, isInvalid: (this.state.descriptionValue && this.state.descriptionValue.length > 120) ? true : false, onChange: function (e) {
                    e.target.value = e.target.value.toString().slice(0, 120);
                    _this.setState({ descriptionValue: e.target.value }, function () {
                        onChange(_this.state);
                    });
                }, isRequired: true })));
    };
    return CreateClassificationForm;
}(React.Component));
export { CreateClassificationForm };
